import { Context } from "@nuxt/types";

import Api from "@/utils/api";

const DEFAULT_POST_LIMITS = 36;

export default class ActivityPuvlicApi extends Api {
  constructor($axios: Context["$axios"]) {
    super("activityServiceV3", $axios);
  }

  getFeaturedPosts = async (params: PostMeta | null) => {
    return await this.request<ManyActivitiesResponse>({
      method: "GET",
      url: `/v3/activities/posts/global/featured`,
      params: {
        limit: params?.limit || DEFAULT_POST_LIMITS,
        next: params?.next || null,
        includes: ["profiles", "ltks", "posts", "media_objects"],
        styled: true,
      },
    });
  };

  getTrendingTodayPosts = async (params: PostMeta | null) => {
    return await this.request<ManyActivitiesResponse>({
      method: "GET",
      url: `/v3/activities/posts/global/trending`,
      params: {
        limit: params?.limit || DEFAULT_POST_LIMITS,
        next: params?.next || null,
        includes: ["profiles", "ltks", "posts", "media_objects"],
        rank: "24h",
        styled: true,
      },
    });
  };

  getTrendingCreatorPosts = async (params: PostMeta | null) => {
    return await this.request<ManyActivitiesResponse>({
      method: "GET",
      url: `/v3/activities/posts/global/featured`,
      params: {
        limit: params?.limit || DEFAULT_POST_LIMITS,
        next: params?.next || null,
        includes: ["profiles", "ltks", "posts", "media_objects"],
        rank: "24h",
        styled: true,
      },
    });
  };

  getTopSharedPosts = async (params: PostMeta | null) => {
    return await this.request<ManyActivitiesResponse>({
      method: "GET",
      url: `/v3/activities/posts/global/trending`,
      params: {
        limit: params?.limit || DEFAULT_POST_LIMITS,
        next: params?.next || null,
        includes: ["profiles", "ltks", "posts", "media_objects"],
        rank: "deeplink",
        styled: true,
      },
    });
  };

  getPostsByProfileId = async (profileId: string, params: ProfilePostsActivityMeta | null) => {
    return await this.request<ManyActivitiesResponse>({
      method: "GET",
      url: `/v3/activities/posts/profile/${profileId ?? ""}`,
      params: {
        limit: params?.limit || DEFAULT_POST_LIMITS,
        next: params?.next || null,
        includes: params?.includes || ["profiles", "ltks", "posts", "media_objects"],
        rank: params?.rank || "chrono",
      },
    });
  };

  getHashtagPosts = async (hashtagName: string, params: PostMeta | null) => {
    return await this.request<ManyActivitiesResponse>({
      method: "GET",
      url: `/v3/activities/posts/hashtag/${hashtagName ?? ""}`,
      params: {
        limit: params?.limit || DEFAULT_POST_LIMITS,
        next: params?.next || null,
        includes: ["profiles", "ltks", "posts", "media_objects"],
        styled: true,
      },
    });
  };
}
